<script lang="ts">
import Vue, { CreateElement, RenderContext, VNode } from 'vue'

export default Vue.extend({
  name: 'AppTooltip',

  functional: true,

  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'mdi-information-outline',
    },
    bottom: {
      type: Boolean,
      default: true,
    },
    wrap: Boolean,
  },

  render (h: CreateElement, { props, scopedSlots, data }: RenderContext<{ text: string, icon: string; bottom: boolean; wrap: boolean; }>): VNode {
    return h('v-tooltip', {
      props: {
        bottom: props.bottom,
      },
      class: `app-tooltip ${data.class || ''} ${data.staticClass || ''}`.trim(),
      attrs: { ...data.attrs },
      scopedSlots: {
        activator: ({ on, attrs }) => {
          if (scopedSlots.default) {
            return scopedSlots.default({ on, attrs });
          }

          return h('v-icon', {
            ...attrs,
            class: 'cursor-pointer app-tooltip__icon',
            on: { ...on },
          }, props.icon);
        }
      }
    }, [
      h('span', { class: `app-tooltip__text ${props.wrap ? 'app-tooltip__text--wrap' : ''}`.trim() }, props.text),
    ]);
  }
})
</script>
